/** 当前支持的文案语种 */
const SUPPORT_LANGUAGES = [
  'en', // 英语 (English)
  'ja', // 日语 (Japanese)
  'es', // 西班牙语 (Spanish)
  'pt', // 葡萄牙语 (Portuguese)
  'fr', // 法语 (French)
  'id', // 印度尼西亚语 (Indonesian)
  'cs', // 捷克语 (Czech)
  'de', // 德语 (German)
  'it', // 意大利语 (Italian)
  'nl', // 荷兰语 (Dutch)
  'pl', // 波兰语 (Polish)
  'tr', // 土耳其语 (Turkish)
  'uk', // 乌克兰语 (Ukrainian)
  'ko', // 韩语 (Korean)
  'ar', // 阿拉伯语 (Arabic)
  'fa', // 波斯语 (Persian)
  'th', // 泰语 (Thai)
  'hi', // 印地语 (Hindi)
  'vi', // 越南语 (Vietnamese)
];

/** showcase支持的文案语种 */
const SHOWCASE_LANGUAGES = [
  'en', // 英语 (English)
  'ja', // 日语 (Japanese)
  'es', // 西班牙语 (Spanish)
  'fr', // 法语 (French)
  'de', // 德语 (German)
  'it', // 意大利语 (Italian)
  'pt', // 葡萄牙语 (Portuguese)
  'pl', // 波兰语 (Polish)
  'tr', // 土耳其语 (Turkish)
  'nl', // 荷兰语 (Dutch)
  'ar', // 阿拉伯语 (Arabic)
  'ko', // 韩语 (Korean)
];

module.exports = {
  SUPPORT_LANGUAGES,
  SHOWCASE_LANGUAGES,
};
